import { useEffect, useState } from "react";
import { silentMode } from "./silent";

export const useSilentMode = () => {
  const [value, setValue] = useState(silentMode.get());
  useEffect(() => silentMode.subscribe(setValue), []);
  return [value, silentMode.set.bind(silentMode)];
};
